// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__35y50","paramInput":"JobSimulator_paramInput__1EZGu","input":"JobSimulator_input__3_-iy"};